import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './Navigation';
import HomePage from './HomePage';
import PoliticiansPage from './PoliticiansPage';
import PoliticianProfile from './PoliticianProfile';
import AdminPage from './AdminPage';
import './App.css';

function App() {
    return (
        <Router>
            <div className="App">
                <Navigation />

                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/politicians" element={<PoliticiansPage />} />
                    <Route path="/politician/:id" element={<PoliticianProfile />} />
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;